import logger from '@spa/lib/logger';

const iovationLoaderSrc = `/assets/js/iovation-loader-5.x.js`;
const iovationLoaderVersion = 'general5';
const iovationLoaderScriptId = 'bazaarvoice-device-fingerprint-loader';

export interface IovationBlackBox {
  readonly blackbox: string;
  readonly finished: boolean;
}

type IovationGetBlackbox = () => IovationBlackBox | null | undefined;

interface IovationIgloo {
  loader?: { version?: string };
  getBlackbox?: IovationGetBlackbox;
}

type IovationWindow = Window & typeof globalThis & { IGLOO?: IovationIgloo };

let lastFinishedBlackBox: string | null = null;

const resolveIovationWindow = (): IovationWindow | null =>
  typeof window === 'undefined' ? null : (window as IovationWindow);

const resolveGetBlackbox = (): IovationGetBlackbox | null => {
  const iovationWindow = resolveIovationWindow();
  const candidate = iovationWindow?.IGLOO?.getBlackbox;

  return typeof candidate === 'function' ? candidate : null;
};

const isFinishedBlackBox = (
  value: IovationBlackBox | null | undefined
): value is IovationBlackBox =>
  value !== null &&
  value !== undefined &&
  value.finished === true &&
  typeof value.blackbox === 'string' &&
  value.blackbox.length > 0;

export const configureIovationLoader = (): void => {
  const iovationWindow = resolveIovationWindow();
  if (iovationWindow === null) {
    return;
  }

  if (iovationWindow.IGLOO === undefined) {
    iovationWindow.IGLOO = { loader: { version: iovationLoaderVersion } };
  }
};

export const ensureDeviceFingerprintLoader = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(iovationLoaderScriptId) !== null) {
    return;
  }

  try {
    const script = document.createElement('script');
    script.id = iovationLoaderScriptId;
    script.src = iovationLoaderSrc;
    script.async = true;
    document.head.appendChild(script);
  } catch (error) {
    logger.error(error, 'Failed to load Bazaarvoice device fingerprint loader');
  }
};

export const triggerDeviceFingerprintGeneration = (): void => {
  configureIovationLoader();
  ensureDeviceFingerprintLoader();
};

export const readDeviceFingerprint = (): string | null => {
  try {
    const getBlackbox = resolveGetBlackbox();
    if (getBlackbox !== null) {
      const result = getBlackbox();
      if (isFinishedBlackBox(result)) {
        lastFinishedBlackBox = result.blackbox;
      }
    }
  } catch (error) {
    logger.error(error, 'Failed to read Bazaarvoice device fingerprint');
  }
  return lastFinishedBlackBox;
};
